import React, { useContext } from 'react'
import { CAPTCHA_KEY } from '../../../../constants'
import {
  ADSHandler,
  CDA,
  DeviceFingerPrint,
  ReCaptchaProvider,
  ContextApp,
  AffiliateQueryStorage,
} from '@monorepo/service'

const Wrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const {
    setSid,
    dataRegister,
    setDataRegister,
    setIsCdaPending,
    setIsCdaCheck,
    setIsCdaBalancerInfoLoading,
    setCdaBalancerInfo,
  } = useContext(ContextApp)

  return (
    <CDA
      dataRegister={dataRegister}
      setDataRegister={setDataRegister}
      setIsCdaPending={setIsCdaPending}
      setIsCdaCheck={setIsCdaCheck}
      setIsCdaBalancerInfoLoading={setIsCdaBalancerInfoLoading}
      setCdaBalancerInfo={setCdaBalancerInfo}
    >
      <DeviceFingerPrint setSid={setSid} />
      <AffiliateQueryStorage />
      <ADSHandler
        versions={{ v1: true, v2: true }}
        mania={'mania2'}
      />
      <ReCaptchaProvider reCaptchaKey={CAPTCHA_KEY}>{children}</ReCaptchaProvider>
    </CDA>
  )
}

export default Wrapper
